import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'
import { Flex, Icon, Box } from 'Components/UI'

const fullWidthStyles = `
  width: 100%;
`

const fullWidthMenuStyles = `
  width: 100%;
  max-width: 100%;
  left: 0 !important;
  right: 0 !important;
`

const defaultMenuStyles = `
  width: 100%;
  max-width: 260px;
`

export const DropdownWrapper = styled(Box)`
  position: relative;

  ${({ fullWidth }) => fullWidth && fullWidthStyles}

  @media screen and (max-width: ${themeGet('breakpoints.0')}) {
    ${fullWidthStyles}
  }

  & > div {
    display: inline-flex;
    align-items: center;

    ${({ fullWidth }) => fullWidth && fullWidthStyles}

    @media screen and (max-width: ${themeGet('breakpoints.0')}) {
      ${fullWidthStyles}
    }

    & > div:first-child {
      display: inline-flex;
      align-items: center;
      width: 260px;
      ${({ fullWidth }) => fullWidth && 'width: 100%;'}
      min-height: 44px;
      padding: 0 12px;
      border: 1px solid ${themeGet('colors.lightGrey')};
      border-radius: ${themeGet('borderRadius.1')};
      gap: 8px;
      cursor: pointer;
      background-color: transparent;

      @media screen and (max-width: ${themeGet('breakpoints.0')}) {
        width: 100%;
      }

      &:hover {
        background-color: white;
      }

      & > div:first-child {
        flex: 1 1 auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    & > div[class*='Menu'] {
      ${({ fullWidth }) =>
        fullWidth ? fullWidthMenuStyles : defaultMenuStyles}

      @media screen and (max-width: ${themeGet('breakpoints.0')}) {
        ${fullWidthMenuStyles}
      }

      & > div {
        &:hover {
          background-color: ${themeGet('colors.whiteHover')};
        }
      }
    }
  }
`

export const Option = styled(Flex).attrs({
  alignItems: 'center',
})`
  user-select: none;
  cursor: pointer;
  font-weight: 500;
  gap: 6px;
  white-space: nowrap;
  background-color: transparent;
  color: ${themeGet('colors.text')};
  fill: ${themeGet('colors.text')};
  border: none;
  flex: 1 1 auto;
  min-width: 0;

  &:hover {
    color: ${({ activecolor }) =>
      activecolor || themeGet('colors.primaryColor')};
    fill: ${({ activecolor }) =>
      activecolor || themeGet('colors.primaryColor')};
  }
`

export const OptionIcon = styled(Icon).attrs({
  size: 14,
})``

export const OptionLabel = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ActiveStatusBadge = styled.span`
  position: absolute;
  top: -4px;
  right: -4px;
  width: 8px;
  height: 8px;
  background-color: #ef4444;
  border-radius: 50%;
  border: 1px solid white;
  z-index: 10;
`
